<template>
  <b-modal
    :id="'add-item'+modalName"
    :no-close-on-backdrop="true"
    :no-close-on-esc="false"
    :title="$t('Add Item')"
    :ok-title="$t('OK')"
    :cancel-title="$t('Cancel')"
    size="lg"
    cancel-variant="outline-secondary"
    @ok="handleOk"
    @hidden="$emit('clear')"
  >
    <form-user
      v-if="itemType=='user'"
      ref="user_form"
      @submit="$emit('submit')"
      @error="error"
    />
    <form-project
      v-if="itemType=='project'"
      ref="project_form"
      @submit="$emit('submit')"
    />

    <form-page
      v-if="itemType=='page'"
      ref="page_form"
      v-model="editItem"
      :parent-id="parentId"
      @submit="$emit('submit')"
    />

    <form-message
      v-if="itemType=='message'"
      ref="message_form"
      v-model="editItem"
      @submit="$emit('submit')"
    />

    <form-library
      v-if="itemType=='library'"
      ref="library_form"
      v-model="editItem"
      @submit="$emit('submit')"
    />

    <form-hot-alert-condition
      v-if="itemType=='hotalertcondition'"
      ref="hotalertcondition_form"
      v-model="editItem"
      @submit="$emit('submit')"
    />

    <form-holiday
      v-if="itemType=='holiday'"
      ref="holiday_form"
      v-model="editItem"
      @submit="$emit('submit')"
    />

    <form-user-group
      v-if="itemType=='userGroup'"
      ref="userGroup_form"
      v-model="editItem"
      @submit="$emit('submit')"
    />

    <form-scheduled-box
      v-if="itemType=='scheduledBox'"
      ref="scheduledBox_form"
      v-model="editItem"
      @submit="$emit('submit')"
    />

    <form-request
      v-if="itemType=='request'"
      ref="request_form"
      v-model="editItem"
      @submit="$emit('submit')"
    />

  </b-modal>
</template>

<script>
import {
  BModal, VBModal,
} from 'bootstrap-vue'

import FormPage from '@/layouts/components/forms/FormPage.vue'
import FormMessage from '@/layouts/components/forms/FormMessage.vue'
import FormLibrary from '@/layouts/components/forms/FormLibrary.vue'
import FormHotAlertCondition from './forms/FormHotAlertCondition.vue'
import FormUser from './forms/FormUser.vue'
import FormProject from './forms/FormProject.vue'
import FormHoliday from './forms/FormHoliday.vue'
import FormUserGroup from './forms/FormUserGroup.vue'
import FormScheduledBox from './forms/FormScheduledBox.vue'
import FormRequest from './forms/FormRequest.vue'

export default {
  components: {
    BModal,
    FormPage,
    FormMessage,
    FormLibrary,
    FormHotAlertCondition,
    FormUser,
    FormProject,
    FormHoliday,
    FormUserGroup,
    FormScheduledBox,
    FormRequest,
  },
  directives: {
    'b-modal': VBModal,
  },
  props: {
    modalName: {
      type: String,
      default: '',
    },
    itemType: {
      type: String,
      default: null,
    },
    editItem: {
      type: Object,
      default: null,
    },
    parentId: {
      type: Number,
      default: null,
    },
  },
  methods: {
    error(msg) {
      this.inProgress = false
      this.$swal({
        icon: 'error',
        title: 'Error!',
        text: msg.indexOf('email_unique') > -1 ? this.$t('Email exists!') : msg,
        customClass: {
          confirmButton: 'btn btn-danger',
        },
      })
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.$refs[`${this.itemType}_form`].validationForm()
    },
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>
<style>
.vs__dropdown-toggle {
  border:1px solid #d8d6de !important
}
</style>
